import { useContext } from 'react';
import { ModalDispatchContext, ModalStateContext } from './provider';

export const useModalState = () => {
  const context = useContext(ModalStateContext);
  if (context === undefined) {
    throw new Error(
      'useModalState должен использоваться внутри ToggleModalsVisibleProvider'
    );
  }
  return context;
};

export const useModalDispatch = () => {
  const context = useContext(ModalDispatchContext);
  if (context === undefined) {
    throw new Error(
      'useModalDispatch должен использоваться внутри ToggleModalsVisibleProvider'
    );
  }
  return context;
};
